export default __webpack_public_path__ + "static/media/Certificate-backgroud.e31839d6.jpg";